import { CommonListDataHolder, CommonSinbleDataHolder } from "../sub/DataHolder";
import * as auRequests from "../au_commonRequest";
import { parseAppCofigToEntry, parseCustomerToEntry, parseEnvHwToEntry, parseMesurmentToEntry } from "../sub/dataParser";
import { MesurmentStore } from "../probeStore";
export const TanixUsers = new CommonListDataHolder(() => (auRequests.listCustomer()), parseCustomerToEntry, (trgKey) => ((data) => Boolean(data.uid === trgKey)), "Can not load TanixUsers list");
/* export const Orders = new CommonListDataHolder<MesurmentFull, MesurmentIn, number>(
    () => (auRequests.listMeasurement()),
    parseMesurmentToEntry,
    (trgKey) => ((data) => Boolean(data.uid === trgKey)),
    "Can not load Orders list"); */
export const Orders = new CommonListDataHolder(() => (auRequests.listMeasurement()), parseMesurmentToEntry, (trgKey) => ((data) => Boolean(data.static.id === trgKey)), "Can not load Orders list");
export const EnvHw = new CommonListDataHolder(() => (auRequests.listEnvHw()), parseEnvHwToEntry, (trgKey) => ((data) => Boolean(data.uid === trgKey)), "Can not load Enviroment Hardware list");
export const AppSetings = new CommonSinbleDataHolder(() => (auRequests.getAppConfig()), parseAppCofigToEntry, "Can not load App setings");
export async function getAllTanixUsers() {
    return await TanixUsers.getAll();
}
export async function getAllOrders() {
    return await Orders.getAll();
}
export async function getTanixUser(dbUid) {
    return await TanixUsers.getByKey(dbUid);
}
export async function getOrder(dbUid) {
    return await Orders.getByKey(dbUid);
}
export async function addOrReplaceOrder(orderIn) {
    const data = await parseMesurmentToEntry(orderIn);
    const objExist = Orders.getByKey(data.static.id);
    if (!Orders.replace(data, data.static.id)) {
        Orders.add(data);
    }
    MesurmentStore.add(data, data.uid);
    // const mesList = await Orders.getAll();
    // MesurmentStore.addAll(mesList, mesList.map(mes => mes.uid));
    return {
        newObj: data
    };
}
